import React, { useState, useEffect, useRef, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import {
    Form,
    Button,
    Row,
    Col,
    Card,
    Input,
    CardBody,
    FormGroup,
    Label,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap'
import { connect } from 'react-redux'
import { isEmpty, head, get } from 'lodash'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context/'

const FormPage = (props) => {
  const generalContext = useContext(GeneralContext)
  const { setLoading } = generalContext

  const [calle, setCalle] = useState('')
  const [numeroExterior, setNumeroExterior] = useState('')
  const [numeroInterior, setNumeroInterior] = useState('')
  const [colonia, setColonia] = useState('')
  const [cp, setCp] = useState('')
  const [localidad, setLocalidad] = useState('')
  const [entreCalles, setEntreCalles] = useState('')
  const [municipio, setMunicipio] = useState('')
  const [states, setStates] = useState([])
  const [stateId, setStateId] = useState('')
  const [countries, setCountries] = useState([])
  const [countryId, setCountryId] = useState('')

  const inputCalleRef = useRef(null)
  const [saveModal, setSaveModal] = useState(false)

  const userAddressId = get(props, 'match.params.id', false)

  const toggleSaveModal = () => setSaveModal(!saveModal)

  useEffect(() => {
    (async () => {
      await fetchCountries()
    })()

    async function fetchCountries() {
      setLoading(true)
      const response = await ApiService.getCountries('MX')
      let countries = []
      response.data.data.map((item) => {
        const row = {
          value: item.id,
          label: item.nameEn,
        }
        return countries.push(row)
      })
      setCountries(countries)
      if (countries.length === 1) {
        setCountryId(head(countries).value)
      }
      setLoading(false)
      inputCalleRef.current.focus()
    }
  }, []) // eslint-disable-line

  useEffect(() => {
    (async () => {
      if (!isEmpty(countryId)) {
        await fetchStates(countryId)
      }
    })()

    async function fetchStates() {
      setLoading(true)
      const response = await ApiService.getStatesByCountry(countryId)
      let states = []
      response.data.data.map((item) => {
        const row = {
          value: item.id,
          label: item.nomEstado,
        }

        return states.push(row)
      })
      setStates(states)
      setLoading(false)
    }
  }, [countryId]) // eslint-disable-line

  useEffect(() => {
    (async () => {
      if (!isEmpty(userAddressId)) {
        await fetchOrderDetail(userAddressId)
      }
    })()

    async function fetchOrderDetail(id) {
      setLoading(true)
      const response = await ApiService.getUserAddressById(id)
      setCalle(response.data.data.calle)
      setNumeroExterior(response.data.data.numeroExterior)
      setNumeroInterior(response.data.data.numeroInterior)
      setColonia(response.data.data.colonia)
      setCp(response.data.data.cp)
      setLocalidad(response.data.data.localidad)
      setEntreCalles(response.data.data.entreCalles)
      setMunicipio(response.data.data.municipio)
      setStateId(response.data.data.state.id)
      setCountryId(response.data.data.country.id)
      setLoading(false)
    }
  }, [userAddressId]) // eslint-disable-line

  const enableSaveButton = () => {
    if (isEmpty(calle) ||
      isEmpty(numeroExterior) ||
      isEmpty(colonia) ||
      isEmpty(cp) ||
      isEmpty(localidad) ||
      isEmpty(municipio) ||
      isEmpty(stateId) ||
      stateId === '0' ||
      isEmpty(countryId) ||
      countryId === '0') {
        return true
    }

    return false
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    toggleSaveModal()
  }

  const save = async () => {
    toggleSaveModal()
    setLoading(true)

    const data = {
      calle,
      numeroExterior,
      numeroInterior,
      cp,
      colonia,
      localidad,
      entreCalles,
      municipio,
      stateId,
      countryId
    }

    if (!isEmpty(userAddressId)) { 
      data.id = userAddressId
      const response = await ApiService.updateUserAddress(data).catch(error => {
        toastr.error(`No pude editar la dirección de envío. ${error}`, 'Error')
        setLoading(false)
        return
      })

      if (response.data.success) {
        toastr.success(`Dirección de envío editada correctamente.`, '¡Éxito!')
        window.analytics.track(`New user address added`)
        props.history.goBack()
      }

      setLoading(false)
      return
    }

    const response = await ApiService.createUserAddress(data).catch(error => {
      toastr.error(`No pude crear la dirección de envío ${error}`, 'Error')
      setLoading(false)
      return
    })

    if (!isEmpty(response.data)) {
      if (response.data.success) {
        toastr.success(`Dirección de envío guardada correctamente.`, '¡Éxito!')
        props.history.goBack()
      }
    }

    setLoading(false)
  }

  return (
    <React.Fragment>
      <Form id="create" method="POST" onSubmit={ handleSubmit }>
        <Row>
          <Col xs={12}>
            <Card style={{textAlign: 'right'}}>
              <CardBody>
                <Button
                  onClick={() => { props.history.goBack() }}
                  className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2"
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  disabled={enableSaveButton()}
                  className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                >
                  <i className={`mdi mdi-check`}></i> Guardar
                </Button>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Row>
                  <Col sm={3}>
                    <FormGroup>
                      <Label className="control-label">
                        Calle *
                      </Label>
                      <Input
                        type="text"
                        name="calle"
                        id="calle"
                        required
                        value={calle}
                        innerRef={inputCalleRef}
                        placeholder="Calle..."
                        onChange={(event) => {
                          setCalle(event.target.value.toUpperCase())
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={2}>
                    <FormGroup>
                      <Label className="control-label">
                        Número exterior *
                      </Label>
                      <Input
                        type="text"
                        name="numeroExterior"
                        id="numeroExterior"
                        required
                        value={numeroExterior}
                        placeholder="Número exterior..."
                        onChange={(event) => {
                          setNumeroExterior(event.target.value.toUpperCase())
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={2}>
                    <FormGroup>
                      <Label for="numeroInterior">Número interior</Label>
                      <Input
                        type="text"
                        name="numeroInterior"
                        id="numeroInterior"
                        value={numeroInterior}
                        placeholder="Numero interior..."
                        onChange={(event) => {
                          setNumeroInterior(event.target.value.toUpperCase())
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <FormGroup>
                      <Label for="colonia">Colonia *</Label>
                      <Input
                        type="text"
                        name="colonia"
                        id="colonia"
                        value={colonia}
                        required
                        placeholder="Colonia..."
                        onChange={(event) => {
                          setColonia(event.target.value.toUpperCase())
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={2}>
                    <FormGroup>
                      <Label for="cp">Código postal *</Label>
                      <Input
                        type="number"
                        name="cp"
                        id="cp"
                        required
                        maxLength="5"
                        value={cp}
                        placeholder="Código postal..."
                        onChange={(event) => {
                          setCp(event.target.value.toUpperCase())
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm={3}>
                    <FormGroup>
                      <Label for="entreCalles">Entre calles</Label>
                      <Input
                        type="text"
                        name="entreCalles"
                        required
                        id="entreCalles"
                        value={entreCalles}
                        placeholder="Entre calles..."
                        onChange={(event) => {
                          setEntreCalles(event.target.value.toUpperCase())
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={2}>
                    <FormGroup>
                      <Label for="localidad">Localidad *</Label>
                      <Input
                        type="text"
                        name="localidad"
                        required
                        id="localidad"
                        value={localidad}
                        placeholder="Localidad..."
                        onChange={(event) => {
                          setLocalidad(event.target.value.toUpperCase())
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={2}>
                    <FormGroup>
                      <Label for="municipio">Municipio *</Label>
                      <Input
                        type="text"
                        name="municipio"
                        id="municipio"
                        required
                        value={municipio}
                        placeholder="Municipio..."
                        onChange={(event) => {
                          setMunicipio(event.target.value.toUpperCase())
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <Label className="control-label">
                      Estado *
                    </Label>
                    <Input
                      type="select"
                      className="custom-select"
                      value={stateId}
                      id="states"
                      required
                      name="states"
                      onChange={(event) => {
                        setStateId(event.target.value)
                      }}>
                        <option key="0" value="0">Selecciona un estado... </option> 
                        {states.map((item, i) => {
                          return (
                            <option key={i} value={item.value}>{item.label}</option>
                          )
                        })}
                    </Input>
                  </Col>
                  <Col sm={2}>
                    <Label className="control-label">
                      País *
                    </Label>
                    <Input
                      type="select"
                      className="custom-select"
                      value={countryId}
                      id="country"
                      required
                      name="country"
                      onChange={(event) => {
                        setCountryId(event.target.value)
                      }}>
                        <option key="0" value="0">Selecciona un país... </option> 
                        {countries.map((item, i) => {
                          return (
                            <option key={i} value={item.value}>{item.label}</option>
                          )
                        })}
                    </Input>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Form>
      <div>
        <Modal isOpen={saveModal} toggle={toggleSaveModal}>
          <ModalHeader toggle={toggleSaveModal}>Guardar</ModalHeader>
          <ModalBody>
            ¿Estás segura que deseas guardar esta dirección de envío?
          </ModalBody>
          <ModalFooter>
            <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleSaveModal}>Cancelar</Button>{' '}
            <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={save}>Confirmar</Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  return {
    user: state.Login.user
  }
}

export default connect(mapStatetoProps, {})(withRouter(FormPage))
